<template>
	<section>
		<ButtonBack />
		<h1>Impressum</h1>

		<TheBox>
			<p>
				Der Österreichische Werberat ist ein unabhängiges Organ des Vereines „Gesellschaft zur Selbstkontrolle der Werbewirtschaft“. <br />
				Zweck des Vereines: Der österreichische Werberat als Organ des Vereines hat die Aufgabe Fehlentwicklungen bzw. Missbräuche in der Werbung zu
				korrigieren und dient damit sowohl dem Konsumenten als auch der werbetreibenden Wirtschaft.
			</p>

			<h2>Medieninhaber und Herausgeber:</h2>

			<div class="text">
				<span>Verein Gesellschaft zur Selbstkontrolle der Werbewirtschaft</span><br />
				<span>(Österreichischer Werberat)</span><br />
				<span>Wiedner Hauptstraße 57 / III, 1040 Wien</span>
			</div>

			<div class="text">
				<span><strong>Tel: </strong><a href="tel:6645430136" title="Werberat anrufen" class="link" target="_blank">+43 (0) 664 543 0136</a> </span>
				<br />
				<span>
					<strong>E-Mail: </strong>
					<a href="mailto:office@werberat.at" title="E-Mail an Werberat schicken" class="link" target="_blank">office@werberat.at</a>
				</span>
				<br />
				<span>
					<strong>Website: </strong> <a href="https://www.werberat.at/" title="werberat.at" class="link" target="_blank">www.werberat.at</a>
				</span>
			</div>

			<div class="text">
				<strong>Präsident: </strong> Michael STRABERGER<br />
				<strong>Geschäftsführerin: </strong>Mag.a Andrea STOIDL<br />
				<span>Die ZVR-ZAHL (Zahl des Zentralen Vereinsregisters/Bundespolizeidirektion Wien) des Vereins lautet: 693792629</span>
			</div>

			<div class="text no-marginbottom">
				<strong>Design und Programmierung: </strong>k25 Werbeagentur GmbH<br />
				<strong>Website: </strong><a href="https://www.k25.at/" class="link" title="k25 Werbeagentur GmbH" target="_blank">www.k25.at</a>
				<br />
				<strong>E-Mail: </strong><a href="mailto:office@k25.at" class="link" title="E-Mail an k25 Werbeagentur GmbH" target="_blank">office@k25.at</a>
			</div>
		</TheBox>
	</section>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import ButtonBack from '../components/buttons/ButtonBack.vue';
import TheBox from '../components/TheBox.vue';

export default defineComponent({
	name: 'Impressum',
	data() {
		return {};
	},
	components: {
		ButtonBack,
		TheBox,
	},
	computed: {},
	methods: {},
	mounted() {},
});
</script>

<style lang="scss">
#impressum {
	section {
		margin-bottom: 3rem;
	}

	.box {
		p:first-child {
			margin-top: 0;
		}

		div {
			margin-bottom: 2rem;
		}

		h2 {
			margin-top: 2.5rem;
		}

		.link {
			margin-bottom: 0;
		}
	}
}
</style>
